module.exports = __webpack_public_path__ + "img/card.18019c6f.svg";